var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.865 0H23.33c1.096.002 1.985 1.243 1.986 2.773v4.01H.88v-4.01C.88 1.243 1.769.002 2.865 0zm15.231 16.291c.92 0 1.667-.911 1.667-2.036s-.746-2.037-1.667-2.037c-.92 0-1.666.912-1.666 2.037-.002.54.173 1.06.486 1.443.313.382.738.596 1.18.593zm3.721-1.171c-.291.716-.917 1.173-1.604 1.171-.152 0-.303-.023-.45-.067.88-1.118.88-2.82 0-3.938.665-.202 1.37.057 1.811.664.44.608.535 1.454.243 2.17zM2.865 19C1.77 18.998.88 17.999.88 16.766V8.14h24.437v8.627C25.315 18 24.426 18.998 23.33 19H2.865zm16.684-7.82a2.502 2.502 0 0 0-1.264-.346c-1.142 0-2.166.792-2.573 1.992-.408 1.2-.114 2.559.737 3.415.852.856 2.085 1.032 3.1.443 1.16.673 2.58.34 3.402-.799.823-1.138.823-2.77 0-3.908s-2.243-1.471-3.402-.798z",
    fill: "#0A68FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default ForwardRef;